var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 8.79992L9.33301 10.6666L8.33301 7.59992L10.9997 5.66659H7.69967L6.66634 2.66659L5.66634 5.66659H2.33301L4.99967 7.59992L3.99967 10.6666L6.66634 8.79992ZM11.0997 11.0999L10.333 11.2666L11.0663 11.5666V12.3333L11.5663 11.7666L12.2997 12.0333L11.8663 11.3999L12.333 10.7999L11.5663 10.9666L11.0997 10.3333V11.0999ZM12.233 8.83325L11.6663 9.33325L12.433 9.26659L12.7663 9.99992L12.8997 9.23325L13.6663 9.16659L12.9997 8.76659L13.1663 7.99992L12.5997 8.49992L11.933 8.09992L12.233 8.83325ZM12.433 6.23325L12.6663 6.99992L12.8997 6.26659H13.6663L13.0663 5.79992L13.2997 5.03325L12.6663 5.49992L12.0663 4.99992L12.2997 5.76659L11.6663 6.19992L12.433 6.23325ZM11.0997 3.56659V4.33325L11.5663 3.69992L12.333 3.86659L11.8663 3.26659L12.2997 2.63325L11.5663 2.93325L11.0663 2.33325V3.09992L10.333 3.39992L11.0997 3.56659Z",
    fill: "#FFE62E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.e5812268bf222d4bd8ff5f7c12ba6cad.svg";
export { ForwardRef as ReactComponent };